import React from 'react';
import { useParams } from 'react-router-dom';
import TripsView from './trips-view';

const TripsContainer = () => {
  const { travelerId } = useParams();

  return (
    <TripsView
      travelerId={travelerId}
    />
  );
};

export default TripsContainer;
